import { MDTApi } from './mdtapi.js';

export const fetchReturnCartItems = async (wishlistId) => {
    if (!wishlistId) {
        throw new Error('Missing required parameter wishlistId')
    }

    return await MDTApi.call('api.returns.cartItems', {
        method: 'GET',
    }, {
        cartid: wishlistId
    });
};

export const fetchReturnsWishlist = async () => {
    return MDTApi.call('api.wishlist.cart', {
        method: 'GET',
        params: {
            cartType: 'RETURN'
        }
    });
};


export const fetchOrderFromReturnCart = async (data) => {
    if (!data) {
        throw new Error('Missing required parameter data')
    }

    return MDTApi.call('api.returns.checkout', {
        method: 'POST',
        data
    }, true);
};

export const fetchPackingInformation = async (packingType, supplierInfo) => {
    if (!packingType || !supplierInfo) {
        throw new Error('Missing required parameter packingType || supplierInfo')
    }

    return MDTApi.call('api.common.getPackingInformation', {
        method: 'GET',
    }, {
        packingType,
        supplierInfo,
    });
};

export const fetchReturnReasons = async (territoryId) => {
    if (!territoryId) {
        throw new Error('Missing required parameter territoryId')
    }

    return MDTApi.call('api.returns.reasons', {
        method: 'GET',
    }, {
        territoryId,
    });
};

export const sendRemoveItemFromReturnsCart = async (wishlistId, itemsToDelete) => {
    if (!wishlistId || !itemsToDelete) {
        throw new Error('Missing required parameter wishlistId || itemsToDelete')
    }

    return await MDTApi.call('api.returns.removeItemsFromCart', {
        method: 'POST',
        data: itemsToDelete
    }, {
        wishlistId
    });

};

export const sendUpdateItemForReturnsWizard = async (data, wishlistid) => {
    if (!wishlistid || !data) {
        throw new Error('Missing required parameter wishlistId || data')
    }
    return await MDTApi.call('api.quickOrder.addToCart', {
        method: 'PATCH',
        data:data
    }, {cartId: wishlistid});
}

export const postItemsToReturnCart = async (data, wishlistId) => {
    if (!wishlistId || !data) {
        throw new Error('Missing required parameter wishlistId || data')
    }

    return await MDTApi.call('api.returns.addItemToWishlist', {
            method: 'POST',
            data
        },
        {
            wishlistId
        }
    );
};

export const postReturnOrderSubmit = async (data) => {
    if (!data) {
        throw new Error('Missing required parameter data')
    }

    return await MDTApi.call('api.returns.submit', {
            method: 'POST',
            data
        }
    );
};

export const fetchReturnableItemsForOrder = async (orderId) => {
    if (!orderId) {
        throw new Error('Missing required parameter orderId')
    }

    return await MDTApi.call('api.returns.getReturnableItemsForOrder', {
            method: 'GET'
        },
        {
            orderId
        }
    );
};

export const fetchReturnEligible = async (data, wishlistId) => {
    if (!wishlistId) {
        throw new Error('Missing required parameter wishlistId')
    }
    //Note:  Actual API is not available, we will change MDTAPI.call params and pathvar based on actual API in sprint 7
    return await MDTApi.call('api.returns.returnEligible', {
            method: 'POST',
            data,
            errorCallback: () => {
            }
        },
        wishlistId
    );
};
